import React, { ReactNode } from 'react';

import { View } from 'react-native';
import { StyleSheet } from 'react-native';

import Currency from 'components/currency';
import { useEnableUnifiedMenu } from 'hooks/use-enable-unified-menu';
import { CartItemOfferDiscount } from 'pages/cart/cart-item/cart-item-offer-discount';
import { CartItemOfferDiscountSkeleton } from 'pages/cart/cart-item/cart-item-offer-discount.skeleton';
import { useCartContext } from 'state/cart';
import { selectors, useAppSelector } from 'state/global-state';
import { t } from 'state/intl/translations';
import { useUnifiedMenuContext } from 'state/unified-menu/unified-menu-context';
import { getDesignToken } from 'styles/constants';

import { GrandTotalLabel } from '../your-cart/totals/styled';

import { SkeletonStyled, TotalContainer } from './styled';

interface StickyFooterProps {
  priceTooLowCmp: ReactNode;
  CTAButton: ReactNode;
  isLoading: boolean;
  orderTotal: number;
}

export const CheckOutStickyFooter: React.FC<StickyFooterProps> = ({
  priceTooLowCmp,
  CTAButton,
  isLoading: isExternalLoading,
  orderTotal,
}) => {
  const { priceOrderFailure } = useCartContext();
  const { indexedMenu } = useUnifiedMenuContext();
  const isUnifiedMenuEnabled = useEnableUnifiedMenu();

  const isLoading = isExternalLoading || (isUnifiedMenuEnabled && !indexedMenu.isLoaded());

  const appliedLoyaltyDiscountOffer = useAppSelector(
    selectors.loyalty.selectDiscountAppliedCmsOffer
  );

  const totalContainer = priceOrderFailure ? null : (
    <TotalContainer>
      <GrandTotalLabel fontSize={'xl'} flexGrow={0}>
        {t('total') + ': '}
      </GrandTotalLabel>
      <Currency
        testID="grand-total"
        amount={orderTotal}
        isBold
        textProps={{
          color: getDesignToken('text-default'),
          margin: 0,
          flexGrow: 0,
          fontSize: 'xl',
        }}
      />
    </TotalContainer>
  );

  return (
    <View testID="cart-payment" style={styles.buttonContainer}>
      {appliedLoyaltyDiscountOffer ? (
        isLoading ? (
          <CartItemOfferDiscountSkeleton selectedLoyaltyOffer={appliedLoyaltyDiscountOffer} />
        ) : (
          <CartItemOfferDiscount selectedLoyaltyOffer={appliedLoyaltyDiscountOffer} />
        )
      ) : null}
      {priceTooLowCmp}
      {isLoading ? <SkeletonStyled /> : totalContainer}
      {CTAButton}
    </View>
  );
};

const styles = StyleSheet.create({
  buttonContainer: {
    alignItems: 'center',
    width: '100%',
  },
});
